





















































import type { MergeValues, EBlockWidth, Signature, Context } from '@getaccept/editor-lib';
import { RowType } from '@getaccept/editor-lib';
import type { PropType } from '@vue/composition-api';
import { ref, computed, defineComponent } from '@vue/composition-api';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import VerifySignature from '@getaccept/lib-shared/src/signing/components/VerifySignature.vue';
import { ModalSize } from '@getaccept/lib-ui';
import { SignatureHelper } from '@getaccept/editor-lib/src/helpers/signature.helper';
import type { PartiallySignedEvent } from '@getaccept/editor-lib/src/types/signed-field';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
import SignatureItem from './SignatureItem.vue';

export default defineComponent({
  name: 'EditorNodeSignature',
  components: {
    EditorNodeWrapper,
    SignatureItem,
    VerifySignature,
  },
  props: {
    node: { type: Object as PropType<Signature>, default: () => ({}) },
    mergeValues: { type: Object as PropType<MergeValues>, required: true },
    rowType: { type: String as PropType<RowType>, default: RowType.Standard },
    parentFirstChild: { type: Boolean, default: false },
    parentLastChild: { type: Boolean, default: false },
    blockWidthClass: { type: String as PropType<EBlockWidth>, default: null },
    recipient: { type: Object as PropType<Recipient>, default: () => ({}) },
    sender: { type: Object as PropType<User>, default: () => ({}) },
    isSigningSite: { type: Boolean, default: false },
    focusedRequiredId: { type: String, default: null },
    partiallySignedFields: { type: Array as PropType<PartiallySignedEvent[]>, default: () => [] },
    context: { type: String as PropType<Context>, default: null },
    isPdfViewer: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const rowTypeClass = computed(() => `row-type-${props.rowType?.toLowerCase()}`);
    const showSignatureModal = ref(false);
    const isLoadingSignature = ref(false);

    const getVisibleSignatures = computed(() => {
      return SignatureHelper.getVisibleFields(props.node.fields);
    });

    const handleVerifySignature = async ({ signatureBase64, signatureBase30 }) => {
      showSignatureModal.value = false;
      isLoadingSignature.value = true;
      emit('partially-sign', { signatureBase64, signatureBase30, nodeId: props.node.id });
    };

    const handleShowSignatureModal = () => {
      if (!(props.recipient as Recipient).signature) {
        showSignatureModal.value = true;
        return;
      }
      handleVerifySignature({
        signatureBase64: (props.recipient as Recipient).signature,
        signatureBase30: {},
      });
    };

    return {
      rowTypeClass,
      getVisibleSignatures,
      handleShowSignatureModal,
      showSignatureModal,
      handleVerifySignature,
      ModalSize,
      isLoadingSignature,
    };
  },
});
